module.exports = __webpack_public_path__ + "static/media/piper-dialog3-desktop-es.13db327f.svg";